import { TypedDocumentNode } from '@graphql-typed-document-node/core'

import i18n from 'modules/core/lib/i18n'

import { AssignmentsManager } from 'modules/cost_centers/components/CostCenterAssigments/components/AssignmentsManager'
import { BaseCard } from 'modules/cost_centers/components/CostCenterAssigments/components/Cards/BaseCard'
import { CostCenterAssignment } from 'modules/cost_centers/components/CostCenterAssigments/lib/types'

import { CreateButton } from './components/CreateButton'

interface Props {
  resourceId: string
  resourceType: string
  onCancel: () => void
  onSave: () => Promise<void>
  allAssignments: CostCenterAssignment[]
  refetchQueries?: TypedDocumentNode[]
}

export const CreationCard = ({
  resourceId,
  resourceType,
  onCancel,
  onSave,
  allAssignments,
  refetchQueries,
}: Props) => {
  return (
    <BaseCard focus>
      <AssignmentsManager
        resourceId={resourceId}
        resourceType={resourceType}
        title={i18n.t('finance.cost_centers.assignments.new_assignment_card.title')}
        description={i18n.t('finance.cost_centers.assignments.new_assignment_card.description')}
        isCreating
        onCancel={onCancel}
        onSave={onSave}
        allAssignments={allAssignments}
        customSaveButton={(assignmentsToCreate, assignmentsToUpdate, disabled) => (
          <CreateButton
            refetchQueries={refetchQueries}
            assignments={assignmentsToCreate}
            assignmentsToUpdate={assignmentsToUpdate}
            resourceId={resourceId}
            resourceType={resourceType}
            disabled={disabled}
            onSave={onSave}
          />
        )}
      />
    </BaseCard>
  )
}
